const CONTACT_FOOTER_DATA = [
  {
    id: "1",
    name: "Customer Care",
    links: [
      {
        id: "1",
        name: " Help Center",
        link1: "/",
      },
      {
        id: "2",
        name: "How to Buy",
        link1: "/",
      },
      {
        id: "3",
        name: " Track Your Order",
        link1: "/",
      },
      {
        id: "4",
        name: " Returns & Refunds",
        link1: "/",
      },
    ],
  },
  {
    id: "2",
    name: "Social Links",
    links: [
      {
        id: "1",
        name: "Facebook",
        link1: "/",
      },
      {
        id: "2",
        name: "Tweeter",
        link1: "/",
      },
      {
        id: "3",
        name: "Instagram",
        link1: "/",
      },
      {
        id: "4",
        name: "YouTube",
        link1: "/",
      },
    ],
  },
];

export default CONTACT_FOOTER_DATA;
